import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
var ControlMessage = /*#__PURE__*/function () {
  function ControlMessage(s, t) {
    _classCallCheck(this, ControlMessage);
    this.triggerId = s, this.messageExtras = t, this.triggerId = s, this.messageExtras = t, this.extras = {}, this.isControl = !0, this.kt = !1;
  }
  _createClass(ControlMessage, [{
    key: "Qt",
    value: function Qt() {
      return !this.kt && (this.kt = !0, !0);
    }
  }, {
    key: "Ur",
    value: function Ur() {
      return this.kt;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(s) {
      return new ControlMessage(s.trigger_id, s.message_extras);
    }
  }]);
  return ControlMessage;
}();
export { ControlMessage as default };